export default "__VITE_ASSET__CUjXqJ8p__"